(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-double-carousel"] && !Shopify.designMode) return;
  try {
    
              const img = document.getElementById('carousel');
              const rightBtn = document.getElementById('right-btn');
              const leftBtn = document.getElementById('left-btn');
              const pictures = settingImageSrc.imageSrc.split(',');

              img.src = pictures[0];
              let position = 0;

              const moveRight = () => {
                  if (position >= pictures.length - 1) {
                      position = 0
                      img.src = pictures[position];
                      return;
                  }
                  img.src = pictures[position + 1];
                  position++;
              }

              const moveLeft = () => {
                  if (position < 1) {
                      position = pictures.length - 1;
                      img.src = pictures[position];
                      return;
                  }
                  img.src = pictures[position - 1];
                  position--;
              }
              rightBtn.addEventListener("click", moveRight);
              leftBtn.addEventListener("click", moveLeft);
            
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-image-with-slider-test"] && !Shopify.designMode) return;
  try {
    
const containerSlider = document.querySelector('.container-slider');
document.querySelector('.slider').addEventListener('input', (e) => {
  containerSlider.style.setProperty('--position', `${e.target.value}%`);
})
  console.log(containerSlider)
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-image-with-text"] && !Shopify.designMode) return;
  try {
    
              const img = document.getElementById('carousel');
              const rightBtn = document.getElementById('right-btn');
              const leftBtn = document.getElementById('left-btn');
              const pictures = settingImageSrc.imageSrc.split(',');

              img.src = pictures[0];
              let position = 0;

              const moveRight = () => {
                  if (position >= pictures.length - 1) {
                      position = 0
                      img.src = pictures[position];
                      return;
                  }
                  img.src = pictures[position + 1];
                  position++;
              }

              const moveLeft = () => {
                  if (position < 1) {
                      position = pictures.length - 1;
                      img.src = pictures[position];
                      return;
                  }
                  img.src = pictures[position - 1];
                  position--;
              }
              rightBtn.addEventListener("click", moveRight);
              leftBtn.addEventListener("click", moveLeft);
            
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-projects"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Run the DOM change as a view transition where supported, so the poster grows into the player
    const viewTransition = (update) => {
      if (!document.startViewTransition) {
        update();
        return Promise.resolve();
      }
      return document.startViewTransition(update).finished.catch(() => {});
    };

    const parts = (root) => {
      const player = root.querySelector('[data-project-player]');
      return {
        player,
        rows: [...root.querySelectorAll('.tr-project')],
        slides: [...player.querySelectorAll('[data-project-slide]')],
        track: player.querySelector('[data-project-track]'),
        details: player.querySelector('[data-project-player-details]'),
        viewport: player.querySelector('.tr-projects__viewport'),
      };
    };

    // Show project `index` in the player: slide the videos, swap the details, update the controls
    const show = (root, index, animate) => {
      const { player, rows, slides, track, details } = parts(root);
      const count = slides.length;
      const target = Math.max(0, Math.min(count - 1, index));
      const current = player.dataset.active === undefined ? -1 : Number(player.dataset.active);
      if (target === current) return;
      const direction = target > current ? 1 : -1;
      player.dataset.active = target;

      if (!animate) track.style.transition = 'none';
      track.style.transform = `translateX(${target * -100}%)`;
      if (!animate) {
        track.getBoundingClientRect();
        track.style.transition = '';
      }

      slides.forEach((slide, i) => {
        // Only the visible video can be reached with the keyboard or a screen reader
        slide.inert = i !== target;
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === target) video.play().catch(() => {});
        else video.pause();
      });

      player.querySelectorAll('[data-project-go]').forEach((thumb) => {
        if (Number(thumb.dataset.projectGo) === target) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const prev = player.querySelector('[data-project-step="-1"]');
      const next = player.querySelector('[data-project-step="1"]');
      if (prev) prev.disabled = target === 0;
      if (next) next.disabled = target === count - 1;

      // The details slide out and back in from the side the new video comes from
      const fresh = rows[target].querySelector('[data-project-details]').cloneNode(true);
      const old = details.firstElementChild;
      const token = String(Date.now() + Math.random());
      details.dataset.token = token;
      if (!old || !animate || !old.animate) {
        details.replaceChildren(fresh);
        return;
      }
      old
        .animate(
          [
            { opacity: 1, transform: 'none' },
            { opacity: 0, transform: `translateX(${direction * -4}rem)` },
          ],
          { duration: 220, easing: 'ease-in', fill: 'forwards' }
        )
        .finished.then(() => {
          if (details.dataset.token !== token) return;
          details.replaceChildren(fresh);
          fresh.animate(
            [
              { opacity: 0, transform: `translateX(${direction * 4}rem)` },
              { opacity: 1, transform: 'none' },
            ],
            { duration: 360, easing: 'cubic-bezier(0.2, 0, 0, 1)' }
          );
        });
    };

    const close = (root, animate = true) => {
      const { player, rows, slides, viewport } = parts(root);
      if (player.hidden) return;
      slides.forEach((slide) => slide.querySelector('video')?.pause());
      const row = rows[Number(player.dataset.origin)];
      const frame = row.querySelector('.tr-project__frame');
      const update = () => {
        viewport.style.viewTransitionName = '';
        player.hidden = true;
        row.hidden = false;
        if (animate) frame.style.viewTransitionName = 'tr-project-media';
      };
      if (!animate) {
        update();
        return;
      }
      viewport.style.viewTransitionName = 'tr-project-media';
      viewTransition(update).then(() => {
        frame.style.viewTransitionName = '';
      });
    };

    const open = (root, index) => {
      const { player, rows, slides, viewport } = parts(root);
      close(root, false);
      const row = rows[index];
      const frame = row.querySelector('.tr-project__frame');
      frame.style.viewTransitionName = 'tr-project-media';
      viewTransition(() => {
        frame.style.viewTransitionName = '';
        row.before(player);
        row.hidden = true;
        player.hidden = false;
        player.dataset.origin = index;
        delete player.dataset.active;
        viewport.style.viewTransitionName = 'tr-project-media';
        show(root, index, false);
      }).then(() => {
        viewport.style.viewTransitionName = '';
        slides[index]?.querySelector('video')?.focus({ preventScroll: true });
        player.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    };

    document.addEventListener('click', (event) => {
      const root = event.target.closest('[data-tr-projects]');
      if (!root) return;

      const play = event.target.closest('[data-project-play]');
      if (play) {
        open(root, Number(play.dataset.projectPlay));
        return;
      }

      const step = event.target.closest('[data-project-step]');
      if (step) {
        const active = Number(root.querySelector('[data-project-player]').dataset.active);
        show(root, active + Number(step.dataset.projectStep), true);
        return;
      }

      const go = event.target.closest('[data-project-go]');
      if (go) {
        show(root, Number(go.dataset.projectGo), true);
        return;
      }

      if (event.target.closest('[data-project-close]')) close(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tr-media-toggle]');
    if (!button) return;
    const video = button.closest('.tr-showcase').querySelector('.tr-showcase__media-video');
    if (!video) return;

    if (video.paused) {
      video.play().catch(() => {});
      button.classList.remove('is-paused');
      button.setAttribute('aria-label', 'Pause background video');
    } else {
      video.pause();
      button.classList.add('is-paused');
      button.setAttribute('aria-label', 'Play background video');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-slider-image-with-text"] && !Shopify.designMode) return;
  try {
    

                const img = document.getElementById('carousel');
                const rightBtn = document.getElementById('right-btn');
                const leftBtn = document.getElementById('left-btn');
                const pictures = settingImageSrc.imageSrc.split(',');
            
                img.src = pictures[0];
                let position = 0;
            
                const moveRight = () => {
                    if (position >= pictures.length - 1) {
                        position = 0
                        img.src = pictures[position];
                        return;
                    }
                    img.src = pictures[position + 1];
                    position++;
                }

                const moveLeft = () => {
                    if (position < 1) {
                        position = pictures.length - 1;
                        img.src = pictures[position];
                        return;
                    }
                    img.src = pictures[position - 1];
                    position--;
                }
                rightBtn.addEventListener("click", moveRight);
                leftBtn.addEventListener("click", moveLeft);
            
  } catch(e) { console.error(e); }
})();
})();
